function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Col, Row } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

var FileDisplay = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FileDisplay, _React$Component);

  function FileDisplay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleRemove", function (file, index) {
      var onRemove = _this.props.onRemove;
      onRemove && onRemove(file, index);
    });

    return _this;
  }

  var _proto = FileDisplay.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      className: "file-display container"
    }, (this.props.files || []).map(function (file, index) {
      return /*#__PURE__*/React.createElement(Row, {
        key: index,
        className: "file justify-content-between"
      }, /*#__PURE__*/React.createElement(Col, null, file.name), /*#__PURE__*/React.createElement(Col, {
        xs: "auto"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this2.handleRemove(file, index);
        }
      }, /*#__PURE__*/React.createElement(FontAwesome, {
        name: "trash-alt"
      }))));
    }));
  };

  return FileDisplay;
}(React.Component);

export default FileDisplay;